import React, { useEffect, useState } from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { connect } from 'react-redux'

import LangTab from "../../../components/tabs/langTab";
import { LB_ADDRESS, LB_NAME } from "../../../components/i18n/i18n";

import { searchActiveLangs } from "../../../redux/actions/langActions";
import { setLangsInData } from "../../../redux/actions/genericActions";

const HarborLangs = props => {
    const { disableInputs, dataToEdit } = props.harborInfo
    const { dataToEdit:harbor } = props.harborInfo
    const langHarborChilds = harbor?.langs || []

    const [langChilds, setLangChilds] = useState([])

    useEffect( () => {
        if(props.activeLangs.length > 0)
            return

        props.searchActiveLangs();
    },[] )

    useEffect(() => {
        setDataDefault()
    },[ props.activeLangs ])

    useEffect( () => {
        if(dataToEdit != null)
            return

        setDataDefault()
    },[ dataToEdit ])

    const setDataDefault = () => {
        const items = props.activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            name: '',
            address: '',
        }) )

        setLangChilds(items);
    }

    const getLangChilds = () => {
        const langChild = combineLangChilds(langChilds, langHarborChilds);
        return (langChild ? langChild : (langChilds ? langChilds : []));
    }

    const combineLangChilds = (langOptions, langHarborChilds) => {
        if (langOptions && langHarborChilds && langOptions.length > 0 && langHarborChilds.length > 0){

            langOptions.map((child, index) => {
                const langTagIndex = langHarborChilds.findIndex(n => n.lang === child.lang.id);
                if (langTagIndex !== -1)
                    langOptions[index] = { ...langHarborChilds[langTagIndex],lang :  child.lang }
            });

            return langOptions;
        }
    }

    const onInputChange = (e, lang) => {
        const langIndex = langChilds.findIndex(n => n.lang.id === lang.id);

        if(langIndex === -1)
            return;

        const langs = langChilds.slice();

        langs[langIndex] = { ...langs[langIndex], [ e.target.name ]: e.target.value }
        props.setLangsInData(langs);
        setLangChilds(langs);
    }

    const getFormulary = (child, index, disableInputs) => <>
        <Row>
            <Col>
                <FormGroup>
                    <Label >{LB_NAME}</Label>
                    <Input
                        type="text"
                        name="name"
                        placeholder="Ingrese nombre"
                        value={ child.name }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <FormGroup>
                    <Label >{LB_ADDRESS}</Label>
                    <Input
                        type="text"
                        name="address"
                        placeholder="Ingrese dirección"
                        value= { child.address }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<Row>
        <Col>
            <LangTab
                key={"LangId"}
                langChilds={ langChilds }
                getLangChilds={ getLangChilds }
                getFormulary={ getFormulary }
                disableInputs={ disableInputs }
            />
        </Col>
    </Row>)

}

const mapStateToPropsLang = state => ({
    activeLangs : state.langs,
    harborInfo : state.genericInfo,
})

const mapActionsToPropsLang = ({
    searchActiveLangs,
    setLangsInData,
})

export default connect(mapStateToPropsLang, mapActionsToPropsLang)(HarborLangs)